import React, { useEffect } from "react";
import {  Route, Routes } from "react-router-dom";
import ScrollToTopButton from "./global/ScrollToTopButton";

import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/DashboardPage/ProfilePage";
import ReviewPage from "./pages/DashboardPage/ReviewPage";
import MyPropertiesPage from "./pages/DashboardPage/MyPropertiesPage";

import DashboardHeader from "./layout/DashboardHeader";
import Page404 from "./pages/ErrorsPage/404";
import useExternalScripts from "../hooks/useExternalScripts";
import DashboardSidebar from "./layout/DashboardSidebar";
import AddPropertiesPage from "./pages/DashboardPage/AddPropertiesPage";

function DashboardWrapper() {
  useExternalScripts("dashboard-menu.min.js");
  useExternalScripts("dashboard-menu.js");

  useEffect(() => {
    document.body.classList.add("dashboard");
    document.body.classList.add("show");
  }, []);

  return (
    <>
      {/* <Preload /> */}
      <div id="wrapper">
        <div id="pagee" className="clearfix">
          <DashboardHeader />
         
          <DashboardSidebar/>
          <div className="dashboard__content">
            <Routes>
              <Route path="/" Component={DashboardPage} />
              <Route path="/profile" Component={ProfilePage} />
              <Route path="/review" Component={ReviewPage} />
              <Route path="/properties" Component={MyPropertiesPage} />
              <Route path="/properties/new" Component={AddPropertiesPage} />

              <Route path="*" Component={Page404} />
            </Routes>
          </div>
        </div>
      </div>

      <ScrollToTopButton />
    </>
  );
}

export default DashboardWrapper;
